import ResponsiveWrapper from 'components/shared/others/responsive-wrapper/responsive-wrapper';
import Heading from 'components/partials/heading/heading';
import Loader from 'components/partials/loader/loader';
import EmptySpaceContent from 'components/partials/empty-space-content/empty-space-content';

import InsightItem from 'containers/user/insights/insight-item';
import useInsights from 'containers/user/insights/use-insights';

import Icons from 'assets/icons';

const Insights = (): React.JSX.Element => {
  const { loading, insights } = useInsights();

  return (
    <ResponsiveWrapper customClass="mt-8 flex flex-col">
      <Loader loading={loading} fullScreen={false} />
      <div className="flex items-center mb-6 gap-4 mobile:justify-center tablet:justify-start">
        <Heading variant="h1">Insights</Heading>
      </div>

      {!loading && insights.length === 0 ? (
        <div role="status" aria-live="polite" className="flex flex-1 flex-col">
          <EmptySpaceContent
            customClass="flex-1"
            image={
              <Icons.EmptyImage
                customClass="size-20"
                aria-hidden="true"
              />
            }
            text="No insights have been shared yet"
          />
        </div>
      ) : (
        <div className="flex flex-wrap gap-4 mt-4 mobile:justify-center tablet:justify-start">
          {insights.map((insight) => (
            <InsightItem key={insight.id} insight={insight} />
          ))}
        </div>
      )}
    </ResponsiveWrapper>
  );
};

export default Insights;
